import { FC } from 'react';

import { Banknote } from 'lucide-react';

import { cn } from '../../utils';

interface Props {
    readonly className?: string;
}

const MONOBANK_URL = 'https://send.monobank.ua/jar/8MzjhLsCJW';

export const SupportDevelopersLinks: FC<Props> = ({ className }) => {
    return (
        <div className={cn('space-y-2 text-sm', className)}>
            <a
                href={MONOBANK_URL}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center gap-1.5 font-medium text-gray-800 hover:text-black dark:text-slate-200 dark:hover:text-white"
            >
                <Banknote className="h-3.5 w-3.5" />
                Монобанка
            </a>
        </div>
    );
};
